const ItemTypes = {
  ASSIGNED_LABEL: 'assignedLabel',
  UNASSIGNED_LABEL: 'unassignedLabel',
};

export default ItemTypes;
